var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"8"}},[_c('ItemGrid',{attrs:{"items":_vm.items}})],1),_c('v-col',{attrs:{"cols":"4"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }